import React from 'react';
import ReactDOM from 'react-dom';
const { Icon, Logo, Button, StatusPill, Card, Avatar, BarMini, Donut, Tabs, IndiceBadge } = window;
/* ============================================================
   BOOKER — Tela: Detalhe do contrato + Simulador de reajuste
   ============================================================ */
var { useState, useEffect, useRef, useMemo } = React;

function Detalhe({ contratoId, onNavigate, onSaved }) {
  const DB = window.DB;
  const [editando, setEditando] = useState(false);
  const [encerrarModal, setEncerrarModal] = useState(false);
  const [motivoEnc, setMotivoEnc] = useState('');
  const [procEnc, setProcEnc] = useState(false);
  const podeEditar = window.podeEditar ? window.podeEditar() : true;
  const ehAdmin = window.ehAdmin ? window.ehAdmin() : false;
  const { fmtBRL, fmtData, fmtDataLonga, fmtNum, calc, INDICES } = DB;
  const k = DB.contratosComCliente().find(x => x.id === contratoId); // recomputa a cada render (reflete edições salvas)
  if (!k) return <div>Contrato não encontrado.</div>;
  const cli = k.cliente;
  const idx = INDICES[k.indice];
  const correcao = useMemo(() => calc.correcaoAutomatica(k), [k]);

  // Rateio (empresas/matriz-filiais)
  const [rateio, setRateio] = useState(null);
  const [modalRateio, setModalRateio] = useState(null); // null | 'definir' | 'reajustar'
  const recarregarRateio = () => { if (k.dbId) window.Api.apiRateio(k.dbId).then(setRateio).catch(() => {}); };
  useEffect(() => { if (k.dbId) window.Api.apiRateio(k.dbId).then(setRateio).catch(() => {}); }, [k.dbId]);

  // Conformidade (alvarás/certificados das empresas do contrato, por CNPJ)
  const [conform, setConform] = useState(null);
  useEffect(() => { if (k.dbId) window.Api.apiConformidade(k.dbId).then(setConform).catch(() => {}); }, [k.dbId]);

  const venc = k.dias >= 0 && k.dias <= 30;
  const encerrado = k.status === 'Encerrado';
  const projecao = calc.projecao(k, 3);

  async function encerrar() {
    setProcEnc(true);
    try {
      await window.Api.apiEncerrarContrato(k.dbId, motivoEnc.trim());
      setEncerrarModal(false); setMotivoEnc('');
      if (window.recarregarContratos) await window.recarregarContratos();
      if (onSaved) onSaved();
      window.avisar('Contrato encerrado. Ele continua visível, marcado como Encerrado.');
    } catch (e) { window.avisar(e.message); } finally { setProcEnc(false); }
  }
  async function reativar() {
    if (!await window.confirmar('Reativar este contrato? Ele volta a "Ativo" e a renovar normalmente.')) return;
    try {
      await window.Api.apiReativarContrato(k.dbId);
      if (window.recarregarContratos) await window.recarregarContratos();
      if (onSaved) onSaved();
      window.avisar('Contrato reativado.');
    } catch (e) { window.avisar(e.message); }
  }
  const [confValor, setConfValor] = useState(false);
  async function confirmarValor() {
    setConfValor(true);
    try {
      await window.Api.apiConfirmarValor(k.dbId);
      if (window.recarregarContratos) await window.recarregarContratos();
      if (onSaved) onSaved();
      window.avisar('Valor confirmado — não alerta mais neste contrato.');
    } catch (e) { window.avisar(e.message); } finally { setConfValor(false); }
  }

  // Aditivos deste contrato-base (entidade própria, buscada da API)
  const [aditivos, setAditivos] = useState([]);
  const recarregarAditivos = () => { if (k.dbId) window.Api.apiAditivosDoContrato(k.dbId).then(setAditivos).catch(() => {}); };
  useEffect(() => { if (k.dbId) window.Api.apiAditivosDoContrato(k.dbId).then(setAditivos).catch(() => {}); }, [k.dbId]);
  async function aplicarAditivoDb(id) {
    if (!await window.confirmar('Aplicar o rateio deste aditivo ao contrato-base? Isso cria uma nova vigência e preserva o histórico.')) return;
    try {
      const r = await window.Api.apiAditivoAplicar(id);
      window.avisar(`Aplicado: novo total R$ ${r.total} desde ${r.vigencia} (${r.empresas} empresa(s)).`);
      recarregarRateio(); recarregarAditivos();
      if (window.recarregarContratos) window.recarregarContratos();
    } catch (e) { window.avisar(e.message || 'Falha ao aplicar.'); }
  }

  const Field = ({ label, children, mono }) => (
    <div>
      <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 4 }}>{label}</div>
      <div className={mono ? 'mono' : ''} style={{ fontSize: 14.5, fontWeight: 600, color: 'var(--text-strong)' }}>{children}</div>
    </div>
  );

  // badge de status de alvará/certificado na seção Conformidade
  const badgeConf = (s) => {
    if (!s) return <span style={{ fontSize: 11.5, color: 'var(--text-faint)', fontWeight: 600 }}>— sem registro</span>;
    const map = { vencido: ['var(--danger)', 'var(--danger-bg)'], critico: ['var(--danger)', 'var(--danger-bg)'], atencao: ['var(--booker-orange)', 'var(--warn-bg)'], ok: ['var(--ok)', 'var(--info-bg)'] };
    const [cor, bg] = map[s.estado] || ['var(--text-faint)', 'var(--surface-inset)'];
    const txt = s.estado === 'vencido' ? `Vencido há ${Math.abs(s.dias)}d` : (s.dias != null ? `${s.dias}d` : '—');
    return <span style={{ fontSize: 11.5, fontWeight: 700, color: cor, background: bg, padding: '3px 8px', borderRadius: 99, whiteSpace: 'nowrap' }}>{txt}{s.vencimento ? ` · ${fmtData(s.vencimento)}` : ''}{s.tipo ? ` · ${s.tipo}` : ''}</span>;
  };

  return (
    <div style={{ animation: 'fadeUp .4s ease both' }}>
      {/* Breadcrumb + header */}
      <button onClick={() => onNavigate('contratos')} style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'none', border: 'none',
        color: 'var(--text-muted)', fontSize: 13.5, fontWeight: 600, padding: 0, marginBottom: 14 }}>
        <Icon name="chevronR" size={15} style={{ transform: 'rotate(180deg)' }} /> Contratos
      </button>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16, marginBottom: 22 }}>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', minWidth: 0, flex: 1 }}>
          <Avatar name={cli.fantasia} size={54} />
          <div style={{ minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 4 }}>
              <span className="mono" style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)' }}>{k.codigo}</span>
              <StatusPill status={venc && k.status === 'Ativo' ? 'A renovar' : k.status} />
            </div>
            <h1 style={{ margin: 0, fontSize: 23, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em', lineHeight: 1.18 }}>{cli.razao}</h1>
            <div style={{ marginTop: 5, fontSize: 13, color: 'var(--text-muted)' }}>{k.objeto}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {podeEditar && <Button variant="default" icon="edit" onClick={() => setEditando(true)}>Editar</Button>}
          <Button variant="default" icon="external" onClick={() => k.arquivo && window.Api.abrirArquivo(k.arquivo)}>Abrir contrato</Button>
          {ehAdmin && (encerrado
            ? <Button variant="default" icon="refresh" onClick={reativar}>Reativar</Button>
            : <Button variant="default" icon="x" onClick={() => setEncerrarModal(true)}>Encerrar</Button>)}
        </div>
      </div>

      {/* Aviso de contrato encerrado */}
      {encerrado && (
        <Card pad={16} style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 14, background: 'var(--surface-inset)', border: '1px solid var(--border-strong)' }}>
          <span style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--surface)', color: 'var(--text-muted)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="x" size={20} /></span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 14.5, fontWeight: 800, color: 'var(--text-strong)' }}>Contrato encerrado{k.encerradoEm ? ` em ${fmtData(k.encerradoEm)}` : ''}</div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Não renova mais e fica fora dos alertas.{k.encerradoPor ? ` Encerrado por ${k.encerradoPor}.` : ''}{k.motivoEncerramento ? ` Motivo: ${k.motivoEncerramento}` : ''}</div>
          </div>
          {ehAdmin && <Button variant="default" icon="refresh" onClick={reativar}>Reativar</Button>}
        </Card>
      )}

      {/* Aviso de revisão pendente */}
      {!encerrado && (k.revisar || !k.valorAtual) && (
        <Card pad={16} style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 14, background: 'var(--warn-bg)', border: '1px solid var(--booker-orange)' }}>
          <span style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--surface)', color: 'var(--booker-orange)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={21} /></span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 14.5, fontWeight: 800, color: 'var(--text-strong)' }}>Contrato a revisar</div>
            <div style={{ fontSize: 13, color: 'var(--text)' }}>{!k.valorAtual ? 'O valor mensal não foi identificado na extração. Preencha para concluir.' : 'Confira e ajuste os dados extraídos deste contrato.'}</div>
          </div>
          {podeEditar && <Button variant="accent" icon="edit" onClick={() => setEditando(true)}>Resolver agora</Button>}
        </Card>
      )}

      {/* Aviso de valor baixo não confirmado (ex.: contrato real de R$ 75) */}
      {!encerrado && k.valorInicial != null && k.valorInicial > 0 && k.valorInicial < 100 && !k.valorConferido && (
        <Card pad={16} style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 14, background: 'var(--warn-bg)', border: '1px solid var(--booker-orange)' }}>
          <span style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--surface)', color: 'var(--booker-orange)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={21} /></span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 14.5, fontWeight: 800, color: 'var(--text-strong)' }}>Valor inicial muito baixo · {fmtBRL(k.valorInicial)}</div>
            <div style={{ fontSize: 13, color: 'var(--text)' }}>Pode ser erro de extração (ex.: 7.500 virou 75) — ou um contrato realmente baixo. Confirme se estiver certo para não alertar mais.</div>
          </div>
          {podeEditar && <Button variant="accent" icon={confValor ? undefined : 'check'} onClick={confValor ? undefined : confirmarValor}>{confValor ? 'Confirmando…' : 'Confirmar valor'}</Button>}
        </Card>
      )}

      {/* KPI strip */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginBottom: 18 }}>
        <MiniStat label="Valor mensal atual" value={fmtBRL(k.valorAtual)} tone="var(--text-strong)" />
        <MiniStat label="Próximo reajuste" value={fmtData(correcao.proxima)} tone="var(--text-strong)"
          sub={`${idx.label} · ${k.periodicidade}m`} />
        <MiniStat label="Valor corrigido hoje" value={fmtBRL(correcao.valorDevido)} tone="var(--booker-orange)"
          sub={correcao.ciclosPendentes > 0 ? `${correcao.ciclosPendentes} reajuste(s) · ${idx.label}` : 'sem reajuste ainda'} />
        <MiniStat label={encerrado ? 'Situação' : 'Renova em'} value={encerrado ? 'Encerrado' : `${Math.abs(k.dias)} dias`}
          tone={encerrado ? 'var(--text-muted)' : venc ? 'var(--warn)' : 'var(--text-strong)'} sub={encerrado ? (k.encerradoEm ? fmtData(k.encerradoEm) : '—') : fmtData(k.dataVencimento)} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1.25fr) minmax(0, 1fr)', gap: 18, alignItems: 'start' }}>
        {/* ESQUERDA */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {/* Informações extraídas */}
          <Card>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <Icon name="sparkles" size={18} style={{ color: 'var(--booker-orange)' }} />
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-strong)' }}>Informações extraídas</h3>
              </div>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'var(--ok-bg)', color: 'var(--ok)',
                fontSize: 12, fontWeight: 700, padding: '4px 10px', borderRadius: 99 }}>
                <Icon name="check" size={13} /> {Math.round(k.confianca * 100)}% confiança · {k.modelo}
              </span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px 20px' }}>
              <Field label="Razão social">{cli.razao}</Field>
              <Field label={(DOC_CFG[cli.docTipo] || DOC_CFG.CNPJ).label} mono>{cli.cnpj}{cli.inscricaoEstadual ? <span style={{ color: 'var(--text-muted)' }}> · IE {cli.inscricaoEstadual}</span> : ''}</Field>
              <Field label="Contato responsável">{cli.contato}</Field>
              <Field label="E-mail / Telefone"><span style={{ fontWeight: 500, color: 'var(--text)' }}>{cli.email} · {cli.tel}</span></Field>
              <Field label="Data de início">{fmtDataLonga(k.dataInicio)}</Field>
              <Field label="Data de vencimento">{fmtDataLonga(k.dataVencimento)}</Field>
              <Field label="Valor inicial">{fmtBRL(k.valorInicial)}</Field>
              <Field label="Valor atual">{fmtBRL(k.valorAtual)}</Field>
              <Field label="Índice de reajuste"><IndiceBadge k={k.indice} sub={idx.fonte} /></Field>
              <Field label="Periodicidade">{k.periodicidade === 12 ? 'Anual' : k.periodicidade + ' meses'}</Field>
            </div>
            <div style={{ marginTop: 18, paddingTop: 16, borderTop: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10, fontSize: 12.5, color: 'var(--text-muted)', minWidth: 0 }}>
              <Icon name="doc" size={16} style={{ flexShrink: 0 }} /><span className="mono" style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{k.arquivo}</span><span style={{ flexShrink: 0 }}>·</span><span style={{ flexShrink: 0 }}>{k.pasta}</span>
            </div>
          </Card>

          {/* Empresas e rateio */}
          <Card>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <Icon name="building" size={18} style={{ color: 'var(--booker-orange)' }} />
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-strong)' }}>Empresas e rateio</h3>
              </div>
              {podeEditar && rateio && rateio.linhas.length > 0 && (
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button size="sm" variant="ghost" icon="edit" onClick={() => setModalRateio('definir')}>Editar</Button>
                  {rateio.ativos.length > 0 && <Button size="sm" variant="accent" icon="refresh" onClick={() => setModalRateio('reajustar')}>Reajustar</Button>}
                </div>
              )}
            </div>
            {!rateio ? (
              <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Carregando…</div>
            ) : rateio.linhas.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '14px 0' }}>
                <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 12 }}>Nenhum rateio definido — distribua o valor entre matriz e filiais.</div>
                <Button variant="default" icon="plus" onClick={() => setModalRateio('definir')}>Definir rateio</Button>
              </div>
            ) : (
              <>
                {rateio.ativos.length === 0 && (
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '11px 13px', marginBottom: 12, background: 'var(--warn-bg)', borderRadius: 'var(--r-sm)' }}>
                    <Icon name="alert" size={16} style={{ color: 'var(--booker-orange)', flexShrink: 0, marginTop: 1 }} />
                    <div style={{ fontSize: 12.5, color: 'var(--text)' }}>
                      <b>Nenhuma vigência ativa hoje.</b> Os períodos abaixo estão fora da data atual — provavelmente falta cadastrar o período <b>vigente</b>. Clique em <b>Editar</b> e adicione o período atual deixando o <b>fim vazio</b>.
                    </div>
                  </div>
                )}
                {rateio.ativos.map((l) => (
                  <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                    <span style={{ fontSize: 10, fontWeight: 800, color: l.papel === 'matriz' ? 'var(--booker-orange)' : 'var(--info)', background: l.papel === 'matriz' ? 'var(--warn-bg)' : 'var(--info-bg)', padding: '2px 7px', borderRadius: 5, textTransform: 'uppercase', flexShrink: 0 }}>{l.papel}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.razao || '—'}</div>
                      <div className="mono" style={{ fontSize: 11, color: 'var(--text-muted)' }}>{l.cnpj || '—'}{l.inicio ? <span style={{ fontFamily: 'inherit' }}> · desde {fmtData(l.inicio)}{l.fim ? ` até ${fmtData(l.fim)}` : ''}</span> : ''}</div>
                    </div>
                    <div className="tnum" style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-strong)' }}>{fmtBRL(l.valor)}</div>
                  </div>
                ))}
                {rateio.ativos.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 12 }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-muted)' }}>Total do contrato (hoje)</span>
                    <span className="tnum" style={{ fontWeight: 800, color: 'var(--booker-orange)', fontSize: 16 }}>{fmtBRL(rateio.total)}</span>
                  </div>
                )}
                {rateio.linhas.some(l => !l.ativo) && (
                  <details open={rateio.ativos.length === 0} style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
                    <summary style={{ fontSize: 12.5, color: 'var(--text-muted)', cursor: 'pointer', fontWeight: 600 }}>Vigências fora da data de hoje ({rateio.linhas.filter(l => !l.ativo).length}) — passadas/agendadas</summary>
                    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                      {rateio.linhas.filter(l => !l.ativo).map(l => (
                        <div key={l.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, color: 'var(--text-muted)' }}>
                          <span>{l.razao} <span style={{ color: 'var(--text-faint)' }}>· {l.papel}</span></span>
                          <span className="mono">{fmtBRL(l.valor)} · {fmtData(l.inicio)}→{l.fim ? fmtData(l.fim) : '…'}</span>
                        </div>
                      ))}
                    </div>
                  </details>
                )}
              </>
            )}
          </Card>

          {/* Aditivos vinculados (quando este é o contrato-base) */}
          {aditivos.length > 0 && (
            <Card>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 12 }}>
                <Icon name="link" size={18} style={{ color: 'var(--booker-orange)' }} />
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-strong)' }}>Aditivos ({aditivos.length})</h3>
              </div>
              {aditivos.map((a, i) => (
                <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderTop: i ? '1px solid var(--border)' : 'none' }}>
                  <span style={{ fontSize: 10, fontWeight: 800, color: 'var(--booker-orange)', background: 'var(--warn-bg)', padding: '2px 7px', borderRadius: 5, flexShrink: 0 }}>Nº {a.numeroAditivo || '?'}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{a.arquivo || a.codigo}</div>
                    <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{a.codigo} · vigência {a.dataVigencia ? fmtData(a.dataVigencia) : '—'}{a.aplicadoEm ? ' · ✓ aplicado' : ''}</div>
                  </div>
                  <Button size="sm" variant="ghost" icon="external" onClick={() => window.Api.abrirAditivo(a.arquivo)}>Abrir</Button>
                  {podeEditar && <Button size="sm" variant="accent" icon="refresh" onClick={() => aplicarAditivoDb(a.id)}>Aplicar</Button>}
                </div>
              ))}
            </Card>
          )}

          {/* Conformidade (alvarás e certificados das empresas do contrato) */}
          {conform && conform.totalEmpresas > 0 && (
            <Card>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 12 }}>
                <Icon name="check" size={18} style={{ color: 'var(--booker-orange)' }} />
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-strong)' }}>Conformidade · {conform.totalEmpresas} empresa(s)</h3>
              </div>
              <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginBottom: 12, fontSize: 12.5 }}>
                <ResumoConf label="Alvarás" r={conform.alvaras} />
                <ResumoConf label="Certificados" r={conform.certificados} />
              </div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)', textAlign: 'left', color: 'var(--text-muted)' }}>
                      <th style={{ padding: '7px 8px', fontWeight: 700 }}>Empresa</th>
                      <th style={{ padding: '7px 8px', fontWeight: 700 }}>Alvará</th>
                      <th style={{ padding: '7px 8px', fontWeight: 700 }}>Certificado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {conform.empresas.map((e) => (
                      <tr key={e.empresaId} style={{ borderTop: '1px solid var(--border)' }}>
                        <td style={{ padding: '8px' }}>
                          <div style={{ fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200 }}>{e.razao}</div>
                          <div className="mono" style={{ fontSize: 10.5, color: 'var(--text-faint)' }}>{e.cnpj}</div>
                        </td>
                        <td style={{ padding: '8px' }}>{badgeConf(e.alvara, e.arquivoAlv)}</td>
                        <td style={{ padding: '8px' }}>{badgeConf(e.certificado)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-faint)', marginTop: 10 }}>Resolvido automaticamente pelo CNPJ das empresas vinculadas a este contrato.</div>
            </Card>
          )}

        </div>

        {/* DIREITA — Simulador */}
        <Simulador k={k} correcao={correcao} projecao={projecao} />
      </div>

      {editando && <EditarContrato k={k} onClose={() => setEditando(false)} onSaved={onSaved} />}
      {encerrarModal && ReactDOM.createPortal(
        <div onClick={procEnc ? undefined : () => setEncerrarModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 440, background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Encerrar contrato</h3>
              <button onClick={() => setEncerrarModal(false)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
            </div>
            <div style={{ padding: 22 }}>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 14 }}>O contrato de <b style={{ color: 'var(--text)' }}>{cli.fantasia}</b> vai ficar marcado como <b>Encerrado</b> — continua visível, mas <b>para de renovar</b> e sai dos alertas.</div>
              <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>Motivo (opcional)</label>
              <textarea value={motivoEnc} onChange={e => setMotivoEnc(e.target.value)} rows={3} placeholder="Ex.: cliente encerrou o contrato / rescisão…"
                style={{ width: '100%', padding: '10px 12px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none', resize: 'vertical' }} />
              <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
                <Button variant="default" onClick={() => setEncerrarModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
                <Button variant="accent" icon={procEnc ? undefined : 'check'} onClick={procEnc ? undefined : encerrar} style={{ flex: 1.4, justifyContent: 'center' }}>{procEnc ? 'Encerrando…' : 'Encerrar contrato'}</Button>
              </div>
            </div>
          </div>
        </div>, document.body)}
      {modalRateio === 'definir' && <RateioModal k={k} atual={rateio ? rateio.linhas : []} onClose={() => setModalRateio(null)} onSalvo={() => { setModalRateio(null); recarregarRateio(); if (onSaved) onSaved(); }} />}
      {modalRateio === 'reajustar' && <ReajusteModal k={k} total={rateio ? rateio.total : 0} onClose={() => setModalRateio(null)} onSalvo={() => { setModalRateio(null); recarregarRateio(); if (onSaved) onSaved(); }} />}
    </div>
  );
}

/* ---------------- RATEIO (definir/editar) ---------------- */
function RateioModal({ k, atual, onClose, onSalvo }) {
  const { fmtBRL } = window.DB;
  const hoje = new Date().toISOString().slice(0, 10);
  const [data, setData] = useState((atual && atual[0] && atual[0].inicio) || k.dataInicio || hoje);
  const [linhas, setLinhas] = useState(() => (atual && atual.length)
    ? atual.map(l => ({ empresa_id: l.empresaId, cnpj: l.cnpj, razao: l.razao, papel: l.papel, valor: l.valor, inicio: l.inicio || k.dataInicio || hoje, fim: l.fim || '' }))
    : [{ empresa_id: null, cnpj: k.cliente.cnpj === '—' ? '' : k.cliente.cnpj, razao: k.cliente.razao, papel: 'matriz', valor: k.valorAtual || 0, inicio: k.dataInicio || hoje, fim: '' }]);
  const [empresas, setEmpresas] = useState([]);
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [puxando, setPuxando] = useState(false);
  const [erro, setErro] = useState('');
  const [aviso, setAviso] = useState('');
  useEffect(() => { window.Api.apiEmpresasList().then(setEmpresas).catch(() => {}); }, []);

  // Lê o PDF do contrato e preenche o rateio pelas cláusulas 6 (valores) e 7 (datas).
  async function puxarDoContrato() {
    setErro(''); setAviso(''); setPuxando(true);
    try {
      const s = await window.Api.apiRateioSugestao(k.dbId);
      if (s.dataBase) setData(s.dataBase);
      if (!s.linhas || !s.linhas.length) { setErro(s.aviso || 'Não localizei as cláusulas 6/7 neste contrato.'); return; }
      setLinhas(s.linhas.map(l => ({ empresa_id: l.empresa_id, cnpj: l.cnpj, razao: l.razao, papel: l.papel, valor: l.valor, inicio: l.inicio || s.dataBase || data, fim: '' })));
      const semData = s.linhas.filter(l => !l.inicio && !s.dataBase).length;
      setAviso(s.aviso || `${s.linhas.length} empresa(s) preenchida(s)${semData ? ` · ${semData} sem data` : ''}. Confira e salve.`);
    } catch (e) { setErro(e.message); }
    finally { setPuxando(false); }
  }

  const total = linhas.reduce((s, l) => s + (Number(l.valor) || 0), 0);
  const set = (i, campo, v) => setLinhas(ls => ls.map((l, j) => j === i ? { ...l, [campo]: v } : l));
  const remover = (i) => setLinhas(ls => ls.filter((_, j) => j !== i));
  function adicionar(e) {
    const dig = (e.cnpj || '').replace(/\D/g, '');
    setLinhas(ls => [...ls, { empresa_id: e.id, cnpj: e.cnpj, razao: e.razao, papel: e.papel || (dig.slice(8, 12) === '0001' ? 'matriz' : 'filial'), valor: 0, inicio: data, fim: '' }]);
    setBusca('');
  }
  // Puxa todas as empresas do mesmo grupo (mesmo rótulo de grupo OU mesma raiz de CNPJ).
  function puxarGrupo() {
    const refDig = ((linhas.find(l => l.cnpj) || {}).cnpj || k.cliente.cnpj || '').replace(/\D/g, '');
    const refEmp = empresas.find(e => (e.cnpj || '').replace(/\D/g, '') === refDig);
    const grupo = refEmp && refEmp.grupo;
    const raiz = refDig.slice(0, 8);
    const jaTem = new Set(linhas.map(l => (l.cnpj || '').replace(/\D/g, '')).filter(Boolean));
    const novas = empresas.filter(e => {
      const dig = (e.cnpj || '').replace(/\D/g, '');
      if (!dig || jaTem.has(dig)) return false;
      return (grupo && e.grupo === grupo) || (raiz && dig.slice(0, 8) === raiz);
    }).map(e => {
      const dig = (e.cnpj || '').replace(/\D/g, '');
      return { empresa_id: e.id, cnpj: e.cnpj, razao: e.razao, papel: e.papel || (dig.slice(8, 12) === '0001' ? 'matriz' : 'filial'), valor: 0, inicio: data, fim: '' };
    });
    if (novas.length) setLinhas(ls => [...ls, ...novas]);
  }
  const sug = busca.trim().length >= 2 ? empresas.filter(e => (e.razao || '').toLowerCase().includes(busca.toLowerCase()) || (e.cnpj || '').includes(busca)).slice(0, 6) : [];

  async function salvar() {
    setErro(''); setSalvando(true);
    try {
      await window.Api.apiRateioDefinir(k.dbId, data, linhas.map(l => ({ empresa_id: l.empresa_id, cnpj: l.cnpj, razao: l.razao, papel: l.papel, valor: Number(l.valor) || 0, inicio: l.inicio || data, fim: l.fim || null })), true);
      onSalvo();
    } catch (e) { setErro(e.message); setSalvando(false); }
  }

  const campo = { padding: '8px 10px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13, outline: 'none' };

  return ReactDOM.createPortal(
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 720, maxHeight: '90vh', overflowY: 'auto', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)', position: 'sticky', top: 0, background: 'var(--surface)' }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Rateio do contrato</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: 22 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <label style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--text-muted)' }}>Data-base padrão</label>
            <input type="date" value={data} onChange={e => setData(e.target.value)} style={campo} />
            <span style={{ fontSize: 11.5, color: 'var(--text-faint)' }}>aplicada a novas linhas</span>
          </div>
          <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginBottom: 14, padding: '8px 11px', background: 'var(--surface-inset)', borderRadius: 'var(--r-sm)' }}>
            💡 Para <b>valores escalonados no tempo</b> (ex.: desconto que muda de mês), adicione uma linha por período preenchendo <b>início → fim</b>. Deixe o <b>fim vazio</b> no período atual/em aberto. O sistema cobra o valor vigente na data.
          </div>

          {linhas.map((l, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <select value={l.papel} onChange={e => set(i, 'papel', e.target.value)} style={{ ...campo, width: 90 }}>
                <option value="matriz">Matriz</option><option value="filial">Filial</option>
              </select>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.razao || '—'}</div>
                <div className="mono" style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>{l.cnpj || '—'}</div>
              </div>
              <input type="date" value={l.inicio || ''} onChange={e => set(i, 'inicio', e.target.value)} title="Início da vigência" style={{ ...campo, width: 124, padding: '7px 7px' }} />
              <span style={{ fontSize: 12, color: 'var(--text-faint)' }}>→</span>
              <input type="date" value={l.fim || ''} onChange={e => set(i, 'fim', e.target.value)} title="Fim da vigência (vazio = em aberto)" style={{ ...campo, width: 124, padding: '7px 7px' }} />
              <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>R$</span>
              <input type="number" step="0.01" value={l.valor} onChange={e => set(i, 'valor', e.target.value)} style={{ ...campo, width: 92, textAlign: 'right' }} />
              <button onClick={() => remover(i)} title="Remover" style={{ width: 30, height: 30, borderRadius: 7, border: 'none', background: 'transparent', color: 'var(--text-faint)' }}><Icon name="trash" size={15} /></button>
            </div>
          ))}

          {/* adicionar empresa */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6, marginBottom: 8 }}>
            <Button size="sm" variant="accent" icon="download" onClick={puxando ? undefined : puxarDoContrato}>{puxando ? 'Lendo contrato…' : 'Puxar do contrato (cláusulas 6 e 7)'}</Button>
            <Button size="sm" variant="default" icon="building" onClick={puxarGrupo}>Puxar grupo</Button>
          </div>
          <div style={{ position: 'relative' }}>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="+ Adicionar empresa (razão social ou CNPJ)…" style={{ ...campo, width: '100%' }} />
            {sug.length > 0 && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4, background: 'var(--surface)', border: '1px solid var(--border-strong)', borderRadius: 'var(--r-sm)', boxShadow: 'var(--shadow-lg)', zIndex: 5, maxHeight: 220, overflowY: 'auto' }}>
                {sug.map(e => (
                  <button key={e.id} onClick={() => adicionar(e)} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '8px 11px', border: 'none', borderBottom: '1px solid var(--border)', background: 'transparent', cursor: 'pointer' }}
                    onMouseEnter={ev => ev.currentTarget.style.background = 'var(--surface-2)'} onMouseLeave={ev => ev.currentTarget.style.background = 'transparent'}>
                    <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-strong)' }}>{e.razao}</div>
                    <div className="mono" style={{ fontSize: 10.5, color: 'var(--text-muted)' }}>{e.cnpj}</div>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 18, paddingTop: 14, borderTop: '1px solid var(--border)' }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-muted)' }}>Total</span>
            <span className="tnum" style={{ fontSize: 18, fontWeight: 800, color: 'var(--booker-orange)' }}>{fmtBRL(total)}</span>
          </div>

          {aviso && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12, padding: '10px 13px', background: 'var(--info-bg)', color: 'var(--info)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600 }}><Icon name="info" size={15} /> {aviso}</div>}
          {erro && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12, padding: '10px 13px', background: 'var(--danger-bg)', color: 'var(--danger)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600 }}><Icon name="alert" size={15} /> {erro}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <Button variant="default" onClick={onClose} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
            <Button variant="accent" icon={salvando ? undefined : 'check'} onClick={salvando ? undefined : salvar} style={{ flex: 1.4, justifyContent: 'center' }}>{salvando ? 'Salvando…' : 'Salvar rateio'}</Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

/* ---------------- REAJUSTE do rateio ---------------- */
function ReajusteModal({ k, total, onClose, onSalvo }) {
  const { fmtBRL, fmtNum, INDICES } = window.DB;
  const idx = INDICES[k.indice];
  const hoje = new Date().toISOString().slice(0, 10);
  const [data, setData] = useState(k.dataVencimento || hoje);
  const [pct, setPct] = useState(idx ? idx.acum12 : 0);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const novoTotal = Math.round(total * (1 + (Number(pct) || 0) / 100) * 100) / 100;
  const campo = { padding: '10px 12px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 14, outline: 'none' };

  async function aplicar() {
    setErro(''); setSalvando(true);
    try { await window.Api.apiRateioReajustar(k.dbId, data, Number(pct) || 0); onSalvo(); }
    catch (e) { setErro(e.message); setSalvando(false); }
  }

  return ReactDOM.createPortal(
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 440, background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Reajustar rateio</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: 22 }}>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>Aplica o percentual a todas as empresas. O arredondamento sobra para a matriz; vigência anterior fica no histórico.</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
            <div><label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>A partir de</label><input type="date" value={data} onChange={e => setData(e.target.value)} style={{ ...campo, width: '100%' }} /></div>
            <div><label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>Percentual (%)</label><input type="number" step="0.01" value={pct} onChange={e => setPct(e.target.value)} style={{ ...campo, width: '100%' }} /></div>
          </div>
          {idx && (
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <button onClick={() => setPct(INDICES.IGPM.acum12)} style={{ fontSize: 11.5, fontWeight: 700, padding: '5px 10px', borderRadius: 99, border: '1px solid var(--border-strong)', background: 'var(--surface)', color: INDICES.IGPM.color, cursor: 'pointer' }}>IGP-M {fmtNum(INDICES.IGPM.acum12, 2)}%</button>
              <button onClick={() => setPct(INDICES.IPCA.acum12)} style={{ fontSize: 11.5, fontWeight: 700, padding: '5px 10px', borderRadius: 99, border: '1px solid var(--border-strong)', background: 'var(--surface)', color: INDICES.IPCA.color, cursor: 'pointer' }}>IPCA {fmtNum(INDICES.IPCA.acum12, 2)}%</button>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 14, background: 'var(--surface-inset)', borderRadius: 'var(--r)' }}>
            <div><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Total atual</div><div className="tnum" style={{ fontSize: 16, fontWeight: 700, color: 'var(--text-strong)' }}>{fmtBRL(total)}</div></div>
            <Icon name="chevronR" size={18} style={{ color: 'var(--text-faint)' }} />
            <div style={{ textAlign: 'right' }}><div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Novo total</div><div className="tnum" style={{ fontSize: 16, fontWeight: 800, color: 'var(--booker-orange)' }}>{fmtBRL(novoTotal)}</div></div>
          </div>
          {erro && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12, padding: '10px 13px', background: 'var(--danger-bg)', color: 'var(--danger)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600 }}><Icon name="alert" size={15} /> {erro}</div>}
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <Button variant="default" onClick={onClose} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
            <Button variant="accent" icon={salvando ? undefined : 'refresh'} onClick={salvando ? undefined : aplicar} style={{ flex: 1.4, justifyContent: 'center' }}>{salvando ? 'Aplicando…' : 'Aplicar reajuste'}</Button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

/* ---------------- Validação de documentos ---------------- */
const soDigitos = (s) => (s || '').replace(/\D/g, '');
function cpfValido(s) {
  const c = soDigitos(s);
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
  let soma = 0; for (let i = 0; i < 9; i++) soma += +c[i] * (10 - i);
  let d1 = (soma * 10) % 11; if (d1 === 10) d1 = 0; if (d1 !== +c[9]) return false;
  soma = 0; for (let i = 0; i < 10; i++) soma += +c[i] * (11 - i);
  let d2 = (soma * 10) % 11; if (d2 === 10) d2 = 0; return d2 === +c[10];
}
function cnpjValido(s) {
  const c = soDigitos(s);
  if (c.length !== 14 || /^(\d)\1{13}$/.test(c)) return false;
  const calc = (base) => { let p = base.length - 7, soma = 0; for (let i = 0; i < base.length; i++) { soma += +base[i] * p; p = p === 2 ? 9 : p - 1; } const r = soma % 11; return r < 2 ? 0 : 11 - r; };
  if (calc(c.slice(0, 12)) !== +c[12]) return false;
  return calc(c.slice(0, 13)) === +c[13];
}
const DOC_CFG = {
  CNPJ: { label: 'CNPJ', ph: '00.000.000/0000-00' },
  CPF: { label: 'CPF', ph: '000.000.000-00' },
  IE: { label: 'Inscrição Estadual', ph: 'livre (varia por UF)' },
};

/* ---------------- EDIÇÃO / RESOLVER ---------------- */
function EditarContrato({ k, onClose, onSaved }) {
  const semBanco = !k.dbId; // dados vindos do cache (sem banco) não são editáveis
  const [form, setForm] = useState({
    razao: k.cliente.razao === '—' ? '' : k.cliente.razao,
    cnpj: k.cliente.cnpj === '—' ? '' : k.cliente.cnpj,
    doc_tipo: k.cliente.docTipo || 'CNPJ',
    inscricao_estadual: k.cliente.inscricaoEstadual || '',
    cidade: k.cliente.cidade === '—' ? '' : k.cliente.cidade,
    uf: k.cliente.uf === '—' ? '' : k.cliente.uf,
    valor: k.valorAtual || '',
    valor_inicial: k.valorInicial || '',
    data_ultimo_reajuste: k.ultimoReajuste || '',
    indice: k.indice || 'IGPM',
    periodicidade: k.periodicidade || 12,
    data_inicio: k.dataInicio || '',
    status: k.status || 'Ativo',
    tipo: k.tipo || 'Contrato',
  });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const set = (campo) => (e) => setForm(f => ({ ...f, [campo]: e.target.value }));

  const docCfg = DOC_CFG[form.doc_tipo] || DOC_CFG.CNPJ;
  const docDig = soDigitos(form.cnpj);
  const docAviso = form.doc_tipo === 'CNPJ' && docDig.length === 14 && !cnpjValido(form.cnpj) ? 'CNPJ inválido (dígito verificador).'
    : form.doc_tipo === 'CPF' && docDig.length === 11 && !cpfValido(form.cnpj) ? 'CPF inválido (dígito verificador).'
    : '';

  // Vínculo com empresa cadastrada (Empresas Booker)
  const [empresas, setEmpresas] = useState([]);
  const [buscaEmp, setBuscaEmp] = useState('');
  const [vinculada, setVinculada] = useState(null);
  useEffect(() => { if (!semBanco) window.Api.apiEmpresasList().then(setEmpresas).catch(() => {}); }, []);
  const sugestoes = buscaEmp.trim().length >= 2
    ? empresas.filter(e => (e.razao || '').toLowerCase().includes(buscaEmp.toLowerCase()) || (e.cnpj || '').includes(buscaEmp)).slice(0, 8)
    : [];
  function vincular(e) {
    // empresa cadastrada é sempre PJ -> documento volta a ser CNPJ
    setForm(f => ({ ...f, razao: e.razao || f.razao, cnpj: e.cnpj || f.cnpj, doc_tipo: e.cnpj ? 'CNPJ' : f.doc_tipo }));
    setVinculada(e); setBuscaEmp('');
  }

  async function salvar() {
    setErro(''); setSalvando(true);
    try {
      const campos = { ...form, valor: form.valor === '' ? null : Number(form.valor), periodicidade: Number(form.periodicidade),
        valor_inicial: form.valor_inicial === '' ? null : Number(form.valor_inicial) };
      await window.Api.apiEditarContrato(k.dbId, campos);
      // vínculo de aditivo (endpoint próprio)
      if (onSaved) await onSaved();
      onClose();
    } catch (e) {
      setErro(e.message || 'Falha ao salvar'); setSalvando(false);
    }
  }

  const campo = { width: '100%', padding: '10px 12px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 13.5, outline: 'none' };
  const Label = ({ children }) => <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>{children}</label>;

  return ReactDOM.createPortal(
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: '40px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)', position: 'sticky', top: 0, background: 'var(--surface)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Icon name="edit" size={19} style={{ color: 'var(--booker-orange)' }} />
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Editar contrato</h3>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>

        <div style={{ padding: 22 }}>
          {semBanco ? (
            <div style={{ display: 'flex', gap: 10, padding: 14, background: 'var(--warn-bg)', borderRadius: 'var(--r-sm)', fontSize: 13, color: 'var(--text)' }}>
              <Icon name="alert" size={18} style={{ color: 'var(--booker-orange)', flexShrink: 0 }} />
              <span>Edição indisponível: os dados estão vindo do cache de extração. Conecte o banco PostgreSQL e rode o seed para habilitar a gravação.</span>
            </div>
          ) : (
            <>
              <div style={{ fontSize: 12.5, color: 'var(--text-muted)', marginBottom: 16 }}>Arquivo de origem: <span className="mono">{k.arquivo}</span> · o PDF não é alterado.</div>

              {/* Vincular a empresa cadastrada */}
              <div style={{ marginBottom: 16, padding: 14, background: 'var(--surface-inset)', borderRadius: 'var(--r)' }}>
                <Label>Vincular a uma empresa cadastrada (Empresas Booker)</Label>
                {vinculada ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', background: 'var(--ok-bg)', borderRadius: 'var(--r-sm)' }}>
                    <Icon name="check" size={16} style={{ color: 'var(--ok)', flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-strong)' }}>{vinculada.razao}</div>
                      <div className="mono" style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{vinculada.cnpj}{vinculada.grupo ? ' · ' + vinculada.grupo : ''}</div>
                    </div>
                    <button onClick={() => setVinculada(null)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}><Icon name="x" size={15} /></button>
                  </div>
                ) : (
                  <div style={{ position: 'relative' }}>
                    <input style={campo} value={buscaEmp} onChange={e => setBuscaEmp(e.target.value)} placeholder="Buscar empresa por razão social ou CNPJ…" />
                    {sugestoes.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4, background: 'var(--surface)', border: '1px solid var(--border-strong)', borderRadius: 'var(--r-sm)', boxShadow: 'var(--shadow-lg)', zIndex: 5, maxHeight: 240, overflowY: 'auto' }}>
                        {sugestoes.map(e => (
                          <button key={e.id} onClick={() => vincular(e)} style={{ display: 'block', width: '100%', textAlign: 'left', padding: '9px 12px', border: 'none', borderBottom: '1px solid var(--border)', background: 'transparent', cursor: 'pointer' }}
                            onMouseEnter={ev => ev.currentTarget.style.background = 'var(--surface-2)'} onMouseLeave={ev => ev.currentTarget.style.background = 'transparent'}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-strong)' }}>{e.razao}</div>
                            <div className="mono" style={{ fontSize: 11, color: 'var(--text-muted)' }}>{e.cnpj}{e.grupo ? ' · ' + e.grupo : ''}{e.possuiContrato ? ' · já vinculada' : ''}</div>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                <div style={{ fontSize: 11.5, color: 'var(--text-faint)', marginTop: 7 }}>Selecionar preenche a razão social e o CNPJ automaticamente.</div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div style={{ gridColumn: '1 / -1' }}><Label>Razão social / Nome</Label><input style={campo} value={form.razao} onChange={set('razao')} /></div>
                <div><Label>Tipo de documento</Label>
                  <select style={campo} value={form.doc_tipo} onChange={set('doc_tipo')}>
                    <option value="CNPJ">CNPJ (pessoa jurídica)</option>
                    <option value="CPF">CPF (pessoa física)</option>
                    <option value="IE">Inscrição Estadual</option>
                  </select>
                </div>
                <div><Label>{docCfg.label}</Label>
                  <input style={{ ...campo, ...(docAviso ? { borderColor: 'var(--warn)' } : {}) }} value={form.cnpj} onChange={set('cnpj')} placeholder={docCfg.ph} />
                  {docAviso && <div style={{ fontSize: 11.5, color: 'var(--warn)', marginTop: 4, display: 'flex', alignItems: 'center', gap: 5 }}><Icon name="alert" size={12} /> {docAviso}</div>}
                </div>
                {form.doc_tipo !== 'IE' && (
                  <div><Label>Inscrição Estadual <span style={{ color: 'var(--text-faint)', fontWeight: 400 }}>(opcional)</span></Label><input style={campo} value={form.inscricao_estadual} onChange={set('inscricao_estadual')} placeholder="produtor rural, etc." /></div>
                )}
                <div>
                  <Label>Valor inicial (R$) <span style={{ color: 'var(--text-faint)', fontWeight: 400 }}>· base da correção</span></Label>
                  <input style={campo} type="number" step="0.01" value={form.valor_inicial} onChange={set('valor_inicial')} placeholder="valor original do contrato" />
                </div>
                <div><Label>Valor mensal atual (R$)</Label><input style={campo} type="number" step="0.01" value={form.valor} onChange={set('valor')} placeholder="o que o cliente paga hoje" /></div>
                <div><Label>Cidade</Label><input style={campo} value={form.cidade} onChange={set('cidade')} /></div>
                <div><Label>UF</Label><input style={campo} value={form.uf} onChange={set('uf')} maxLength={2} placeholder="MG" /></div>
                <div><Label>Data de início</Label><input style={campo} type="date" value={form.data_inicio} onChange={set('data_inicio')} /></div>
                <div><Label>Data do último reajuste <span style={{ color: 'var(--text-faint)', fontWeight: 400 }}>(base da divergência)</span></Label><input style={campo} type="date" value={form.data_ultimo_reajuste} onChange={set('data_ultimo_reajuste')} /></div>
                <div><Label>Periodicidade (meses)</Label><input style={campo} type="number" value={form.periodicidade} onChange={set('periodicidade')} /></div>
                <div><Label>Índice de reajuste</Label>
                  <select style={campo} value={form.indice} onChange={set('indice')}>
                    {Object.keys(window.DB.INDICES).map(key => <option key={key} value={key}>{window.DB.INDICES[key].label}</option>)}
                  </select>
                </div>
                <div><Label>Status</Label>
                  <select style={campo} value={form.status} onChange={set('status')}><option>Ativo</option><option>Encerrado</option></select>
                </div>
              </div>
              {erro && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 14, padding: '10px 13px', background: 'var(--danger-bg)', color: 'var(--danger)', borderRadius: 'var(--r-sm)', fontSize: 12.5, fontWeight: 600 }}><Icon name="alert" size={15} /> {erro}</div>}
              <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
                <Button variant="default" onClick={onClose} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
                <Button variant="accent" icon={salvando ? undefined : 'check'} onClick={salvando ? undefined : salvar} style={{ flex: 1.4, justifyContent: 'center' }}>{salvando ? 'Salvando…' : 'Salvar e gravar'}</Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

function ResumoConf({ label, r }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
      <span style={{ fontWeight: 700, color: 'var(--text-muted)' }}>{label}:</span>
      <span style={{ color: 'var(--ok)', fontWeight: 800 }}>{r.ok}✓</span>
      <span style={{ color: 'var(--booker-orange)', fontWeight: 800 }}>{r.avencer}⚠</span>
      <span style={{ color: 'var(--danger)', fontWeight: 800 }}>{r.vencidos}✗</span>
      {r.sem > 0 && <span style={{ color: 'var(--text-faint)' }}>· {r.sem} sem</span>}
    </div>
  );
}

function MiniStat({ label, value, tone, sub }) {
  return (
    <Card pad={16}>
      <div style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em' }}>{label}</div>
      <div className="tnum" style={{ fontSize: 20, fontWeight: 800, color: tone, marginTop: 6, letterSpacing: '-.01em' }}>{value}</div>
      {sub && <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 3 }}>{sub}</div>}
    </Card>
  );
}

/* ---------------- SIMULADOR ---------------- */
function Simulador({ k, correcao, projecao }) {
  const DB = window.DB;
  const { fmtBRL, fmtData, fmtNum, INDICES } = DB;
  const idx = INDICES[k.indice];
  const [comunicado, setComunicado] = useState(false);
  const maxProj = Math.max(...projecao.map(p => p.valor));
  const temCiclos = correcao.aplicacoes.length > 0;
  const diverg = correcao.divergencia;

  return (
    <>
    <Card pad={0} style={{ position: 'sticky', top: 16, overflow: 'hidden' }}>
      <div style={{ padding: '18px 22px', background: 'linear-gradient(135deg, var(--booker-orange), #C97A1E)', color: '#fff' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <Icon name="refresh" size={19} />
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800 }}>Correção monetária (automática)</h3>
        </div>
        <p style={{ margin: '5px 0 0', fontSize: 13, opacity: .9 }}>{idx.label} ({idx.fonte}) · desde o início do contrato · consultivo</p>
      </div>

      <div style={{ padding: 22 }}>
        {temCiclos ? (
          <>
            <div style={{ background: 'var(--warn-bg)', borderRadius: 'var(--r)', padding: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--booker-orange)', textTransform: 'uppercase', letterSpacing: '.04em' }}>Valor corrigido até hoje</div>
              <div className="tnum" style={{ fontSize: 30, fontWeight: 800, color: 'var(--text-strong)', margin: '4px 0 2px' }}>{fmtBRL(correcao.valorDevido)}<span style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-muted)' }}>/mês</span></div>
              <div style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>{correcao.aplicacoes.length} reajuste(s) anual(is) aplicado(s) desde {fmtData(k.dataInicio)}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
              <span style={{ fontSize: 13.5, color: 'var(--text-muted)', minWidth: 0 }}>Valor inicial</span>
              <span className="tnum" style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', whiteSpace: 'nowrap', flexShrink: 0 }}>{fmtBRL(correcao.valorInicial)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
              <span style={{ fontSize: 13.5, color: 'var(--text-muted)', minWidth: 0 }}>Cobrado hoje</span>
              <span className="tnum" style={{ fontSize: 14, fontWeight: 700, color: 'var(--text)', whiteSpace: 'nowrap', flexShrink: 0 }}>{fmtBRL(correcao.valorCobrado)}</span>
            </div>
            {Math.abs(diverg) > 0.5 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                <span style={{ fontSize: 13.5, color: 'var(--text-muted)', minWidth: 0 }}>Divergência <span style={{ color: 'var(--text-faint)' }}>(corrigido − cobrado)</span></span>
                <span className="tnum" style={{ fontSize: 15, fontWeight: 800, color: diverg > 0 ? 'var(--danger)' : 'var(--ok)', whiteSpace: 'nowrap', flexShrink: 0 }}>{diverg >= 0 ? '+' : ''}{fmtBRL(diverg)}</span>
              </div>
            )}
            <div style={{ marginTop: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 8 }}>Memória de cálculo</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12.5, padding: '6px 10px', marginBottom: 5 }}>
                <span className="mono" style={{ color: 'var(--text-muted)' }}>{fmtData(k.dataInicio)} · início</span>
                <span className="tnum" style={{ fontWeight: 700, color: 'var(--text-muted)' }}>{fmtBRL(correcao.valorInicial)}</span>
              </div>
              {correcao.aplicacoes.map((a, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12.5, padding: '6px 10px', background: 'var(--surface-inset)', borderRadius: 8, marginBottom: 5 }}>
                  <span className="mono" style={{ color: 'var(--text-muted)' }}>{fmtData(a.de)} → {fmtData(a.ate)}</span>
                  <span style={{ fontWeight: 700, color: a.pct < 0 ? 'var(--danger)' : 'var(--booker-orange)' }}>{a.pct >= 0 ? '+' : ''}{fmtNum(a.pct, 2)}%</span>
                  <span className="tnum" style={{ fontWeight: 700, color: 'var(--text-strong)' }}>{fmtBRL(a.novo)}</span>
                </div>
              ))}
            </div>
            <button onClick={() => setComunicado(true)} style={{ width: '100%', marginTop: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, padding: '10px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)', fontWeight: 700, fontSize: 13.5 }}><Icon name="mail" size={16} /> Ver comunicado ao cliente</button>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '28px 10px' }}>
            <div style={{ width: 56, height: 56, borderRadius: 99, background: 'var(--ok-bg)', color: 'var(--ok)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="check" size={28} /></div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-strong)' }}>Sem reajuste ainda</div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', margin: '6px 0 0' }}>Contrato recente — nenhum aniversário de reajuste vencido. Próximo em <b>{fmtData(correcao.proxima)}</b>.</p>
          </div>
        )}

        <div style={{ marginTop: 20, paddingTop: 18, borderTop: '1px solid var(--border)' }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 12 }}>Projeção 3 anos · {idx.label} {idx.acum12}% a.a.</div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, height: 78 }}>
            {projecao.map((p, i) => (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, height: '100%', justifyContent: 'flex-end' }}>
                <span className="tnum" style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--text)' }}>{(p.valor / 1000).toFixed(1)}k</span>
                <div style={{ width: '100%', maxWidth: 38, height: Math.max(8, (p.valor / maxProj) * 48), borderRadius: 6, background: i === 0 ? 'var(--text-faint)' : 'var(--booker-yellow)', animation: `growBar .5s ${i * 0.07}s ease both`, transformOrigin: 'bottom' }} />
                <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600 }}>{p.ano}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
    {comunicado && <ComunicadoReajuste k={k} correcao={correcao} onClose={() => setComunicado(false)} />}
    </>
  );
}

function ComunicadoReajuste({ k, correcao, onClose }) {
  const DB = window.DB;
  const { fmtBRL, fmtData, fmtDataLonga, fmtNum, INDICES, HOJE } = DB;
  const cli = k.cliente;
  const idx = INDICES[k.indice];
  const pctEfetivo = (correcao.valorDevido / correcao.valorCobrado - 1) * 100;
  const theme = document.documentElement.getAttribute('data-theme') || 'light';
  const protocolo = `REAJ-${k.codigo}`;
  const [enviado, setEnviado] = useState(false);
  const [copiado, setCopiado] = useState(false);

  const texto = [
    `${fmtDataLonga(HOJE)}`, ``,
    `À ${cli.razao}`, `CNPJ ${cli.cnpj}`, `A/C ${cli.contato}`, ``,
    `Ref.: Reajuste contratual — ${k.codigo}`, ``,
    `Prezado(a) ${cli.contato},`, ``,
    `Em atenção ao contrato em referência, cujo objeto é “${k.objeto}”, e conforme a cláusula de reajuste atrelada ao índice ${idx.label} (${idx.fonte}), comunicamos o reajuste do valor mensal, acumulado no período desde ${fmtData(k.ultimoReajuste)}.`, ``,
    `Valor anterior: ${fmtBRL(correcao.valorCobrado)}`,
    `Índice aplicado: ${idx.label} — ${fmtNum(pctEfetivo, 2)}%`,
    `Novo valor: ${fmtBRL(correcao.valorDevido)}`,
    `Vigência: a partir de ${fmtData(HOJE)}`, ``,
    `Permanecemos à disposição para quaisquer esclarecimentos.`, ``,
    `Atenciosamente,`, `${k.responsavel}`, `Booker — Inteligência de Negócios`,
  ].join('\n');

  function copiar() {
    try { navigator.clipboard.writeText(texto); } catch (e) {}
    setCopiado(true); setTimeout(() => setCopiado(false), 2200);
  }

  const P = ({ children, style }) => <p style={{ margin: '0 0 12px', fontSize: 14, lineHeight: 1.65, color: 'var(--text)', ...style }}>{children}</p>;

  return ReactDOM.createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.6)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 120, animation: 'fadeIn .2s ease both', padding: '32px 20px', overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 600, animation: 'popIn .25s ease both' }}>
        {/* Documento */}
        <div id="comunicado-print" style={{ background: 'var(--surface)', borderRadius: '16px 16px 0 0', boxShadow: 'var(--shadow-lg)', padding: '38px 44px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 26 }}>
            <Logo theme={theme} h={28} />
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 11.5, fontWeight: 800, color: 'var(--booker-orange)', textTransform: 'uppercase', letterSpacing: '.06em', whiteSpace: 'nowrap' }}>Comunicado de Reajuste</div>
              <div className="mono" style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 3 }}>{protocolo}</div>
            </div>
          </div>

          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 18 }}>{fmtDataLonga(HOJE)}</div>

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-strong)' }}>À {cli.razao}</div>
            <div className="mono" style={{ fontSize: 12.5, color: 'var(--text-muted)', marginTop: 2 }}>CNPJ {cli.cnpj}</div>
            <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>A/C {cli.contato}</div>
          </div>

          <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--text-strong)', marginBottom: 16 }}>Ref.: Reajuste contratual — <span className="mono">{k.codigo}</span></div>

          <P>Prezado(a) {cli.contato},</P>
          <P>Em atenção ao contrato em referência, cujo objeto é “{k.objeto}”, e conforme a cláusula de reajuste atrelada ao índice <b style={{ color: 'var(--text-strong)' }}>{idx.label}</b> ({idx.fonte}), comunicamos o reajuste do valor mensal, acumulado no período desde {fmtData(k.ultimoReajuste)}.</P>

          {/* Quadro de valores */}
          <div style={{ border: '1px solid var(--border)', borderRadius: 'var(--r)', overflow: 'hidden', margin: '18px 0' }}>
            {[
              { l: 'Valor anterior', v: fmtBRL(correcao.valorCobrado), c: 'var(--text)' },
              { l: `Índice aplicado (${idx.label})`, v: '+' + fmtNum(pctEfetivo, 2) + '%', c: 'var(--booker-orange)' },
              { l: 'Novo valor mensal', v: fmtBRL(correcao.valorDevido), c: 'var(--text-strong)', strong: true },
              { l: 'Vigência', v: 'a partir de ' + fmtData(HOJE), c: 'var(--text)' },
            ].map((r, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 16px', borderTop: i ? '1px solid var(--border)' : 'none', background: r.strong ? 'var(--warn-bg)' : 'transparent' }}>
                <span style={{ fontSize: 13, color: 'var(--text-muted)', fontWeight: 600 }}>{r.l}</span>
                <span className="tnum" style={{ fontSize: r.strong ? 17 : 14, fontWeight: r.strong ? 800 : 700, color: r.c }}>{r.v}</span>
              </div>
            ))}
          </div>

          <P>Permanecemos à disposição para quaisquer esclarecimentos.</P>
          <div style={{ marginTop: 22 }}>
            <P style={{ margin: '0 0 2px' }}>Atenciosamente,</P>
            <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-strong)' }}>{k.responsavel}</div>
            <div style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>Booker — Inteligência de Negócios</div>
          </div>
        </div>

        {/* Barra de ações */}
        <div style={{ background: 'var(--surface-2)', borderRadius: '0 0 16px 16px', padding: '16px 22px', boxShadow: 'var(--shadow-lg)' }}>
          {enviado ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ width: 38, height: 38, borderRadius: 99, background: 'var(--ok)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="check" size={20} /></span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-strong)' }}>Comunicado enviado</div>
                <div style={{ fontSize: 12.5, color: 'var(--text-muted)' }}>Para {cli.email}</div>
              </div>
              <Button variant="default" onClick={onClose}>Fechar</Button>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <Button variant="primary" icon="send" onClick={() => setEnviado(true)}>Enviar por e-mail</Button>
              <Button variant="default" icon={copiado ? 'check' : 'copy'} onClick={copiar}>{copiado ? 'Copiado!' : 'Copiar texto'}</Button>
              <Button variant="ghost" icon="print" onClick={() => window.print()}>Imprimir</Button>
              <div style={{ flex: 1 }} />
              <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', fontWeight: 700, fontSize: 13.5, padding: 8 }}>Fechar</button>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

Object.assign(window, { Detalhe });
